import { Component, OnInit, AfterViewInit, HostListener, ViewChild , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ItemConfigBase, IItemConfigSetEditable } from "../../../interfaces/iitemconfig";
import { CountryDataTimeline } from "../../../models/countrydatatimeline";
import { CountryDataService } from "../../../services/countrydata.service";
import { CountryDataStatus } from "../../../enums/countrydatastatus";
import { IDropDownView } from "../../../interfaces/idropdowns";
import { ICanComponentDeactivate } from "../../../interfaces/icancomponentdeactivate";
import {Observable} from "rxjs";
import { CountryDataTimelineComponent } from "../../countrydatatimeline/countrydatatimeline.component";
import { ItemConfigManagementItemComponent } from "../itemconfigmanagementitem/itemconfigmanagementitem.component";
import { ConfirmationModalComponent } from "../../confirmationmodal/confirmationmodal.component";

@Component({
    selector: "itemconfigmanagement",
    templateUrl: "./itemconfigmanagement.component.html",
    standalone: true,
    imports: [CommonModule, RouterModule, CountryDataTimelineComponent, ItemConfigManagementItemComponent, ConfirmationModalComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class ItemConfigManagementComponent implements OnInit, ICanComponentDeactivate, AfterViewInit {
    item!: ItemConfigBase;
    itemConfigSet: IItemConfigSetEditable | null = null;
    originalConfigSet: string = "";
    countryDataTimeline!: CountryDataTimeline[];
    countryCode!: string;
    updateText: string = "";
    loaded: boolean = false;
    saveDisabled: boolean = false;
    countryDataStatus: any = CountryDataStatus;
    commentsHidden: boolean = false;
    dropdowns!: IDropDownView[];

    @ViewChild("confirmModal") confirmModal: any;

     constructor(private toastr: ToastrService,
         // private itemConfigService: ItemConfigService,
          private activatedRoute: ActivatedRoute,
          private router: Router,
      //   private latestUpdateService: LatestUpdateService,
        private countryDataService: CountryDataService) { }

    ngOnInit(): void {
        this.dropdowns = this.activatedRoute.snapshot.data["dropdowns"];
        this.itemConfigSet = this.activatedRoute.snapshot.data["configset"];
        this.countryDataTimeline = this.activatedRoute.snapshot.data["timeline"];

        if(this.itemConfigSet) {
            this.item = this.itemConfigSet.itemConfigs[0];
       }
        // reset modified flags on client side only when loading so that only items that have changed are saved
        // to reduce concurrency issues.
        if (this.item) {
            this.resetModifiedFlags(this.item);
        } 
    }

    ngAfterViewInit(): void {
        this.originalConfigSet = JSON.stringify(this.itemConfigSet);
    }

    // @HostListener allows us to also guard against browser refresh, close, etc.
    @HostListener("window:beforeunload")
    canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
      let changedSet:string = JSON.stringify(this.itemConfigSet);
      if (this.originalConfigSet !== changedSet) {
           this.confirmModal.openModal();
          return false;
      } else {
            return true;
        }
    }

    navigatingTo!: string;

    onAccept(): void {
        // reset the the original back to whats currenlty in itemConfigSet, this allows to pass check  in candeactivate
        this.originalConfigSet = JSON.stringify(this.itemConfigSet);
        this.router.navigate([this.navigatingTo]);
         this.confirmModal.closeModal();
    }

    onDecline(): void {
        this.confirmModal.closeModal();
    }

    showConfirmModal(): boolean {
        this.confirmModal.show();
        return false;
    }

    saveChanges(): void {
        // service call to update item
        if (!this.saveDisabled) {
            this.saveDisabled = true;
            this.countryDataService
                .save(this.itemConfigSet)
                .subscribe((res: boolean) => {
                    if (res) {
                        this.originalConfigSet = JSON.stringify(this.itemConfigSet);
                        this.toastr.success("Changes have been successfully saved");
                    }
                    this.saveDisabled = false;
                });
        }
    }

    onCancel(): void {
        this.router.navigate([`/countries/${this.itemConfigSet.country.code}`]);
    }

    /**
     * Click hook to toggle visibility on comments
     */
    toggleComments(): void {
        this.commentsHidden = !this.commentsHidden;
    }

    private resetModifiedFlags(itemCfg: ItemConfigBase): void {
        itemCfg.itemDetail.modified = false;
        itemCfg.children.forEach(i => this.resetModifiedFlags(i));
    }
}



